let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eWDHQ")).then(() => parcelRequire('kZ7N3'));